<!--
  użycie:
   <NfTimer arrival-date="2024-12-12">
      <template #days-label>Dni</template>
      <template #hours-label>Godzin</template>
      <template #minutes-label>Minut</template>
      <template #seconds-label>Seconds</template>
    </NfTimer>

    Jeśli chodzi o style trzeba z poziomu wordpressa to wystlizować.
-->
<template>
  <div class="nf-timer-container">
    <div class="nf-timer-item days">
      <slot name="days-label" class="nf-timer-item__value"></slot>
      <span class="nf-timer-item__label">{{ days }}</span>
    </div>
    <div class="nf-timer-item hours">
      <slot name="hours-label" class="nf-timer-item__value"></slot>
      <span class="nf-timer-item__label">{{ hours }}</span>
    </div>
    <div class="nf-timer-item minutes">
      <slot name="minutes-label" class="nf-timer-item__value"></slot>
      <span class="nf-timer-item__label">{{ minutes }}</span>
    </div>
    <div class="nf-timer-item seconds">
      <slot name="seconds-label" class="nf-timer-item__value"></slot>
      <span class="nf-timer-item__label">{{ seconds }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
const props = defineProps<{
  arrivalDate: string
}>()

const now = ref(new Date())
let intervalId = null as number | null;

const diff = computed(() => {
  const arrival = new Date(props.arrivalDate);
  const duration = arrival.getTime() - now.value.getTime()
  return {
    days: Math.floor(duration / (1000 * 60 * 60 * 24)),
    hours: Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((duration % (1000 * 60)) / 1000)
  }
})

const seconds = computed(() => String(diff.value.seconds).padStart(2, '0'))
const minutes = computed(() => String(diff.value.minutes).padStart(2, '0'))
const hours = computed(() => String(diff.value.hours).padStart(2, '0'))
const days = computed(() => String(diff.value.days).padStart(2, '0'))

onMounted(() => {
  intervalId = setInterval(() => {
    now.value = new Date()
  }, 1000)
})

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})
</script>
